import { useEffect, useRef } from "react";

/**
 * Currently, this utility is exclusively used to log the user out of an existing session after
 * a pre-configured period of idle time (currently 15 minutes). The timer starts when the app starts.
 */
const useLogoutTimers = async ({
  logoutTimerOn = false,
  logOutAction,
  timeLeftToLogout,
  handleSetTimeLeft,
  initialTimeLeftToLogoutSeconds = 30,
}) => {
  let timers = useRef({ timer: null, interval: null });
  let timeLeft = timeLeftToLogout;

  // These useEffect hooks will fail to work correctly when all
  // the hook dependencies are added in order to appease eslint.
  // This linting rule has been disabled here for now. Even
  // Facebook disables the linter from time to time in their
  // own code.
  //
  // See: https://github.com/facebook/create-react-app/issues/6880#issuecomment-486640921

  useEffect(() => {
    if (logoutTimerOn) {
      timers.current.timer = window.setTimeout(async () => {
        logOutAction();
        handleSetTimeLeft(initialTimeLeftToLogoutSeconds);
      }, initialTimeLeftToLogoutSeconds * 1000);
    }

    const timer = timers.current.timer;
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logoutTimerOn]);

  useEffect(() => {
    if (logoutTimerOn) {
      timers.current.interval = window.setInterval(() => {
        timeLeft--;
        handleSetTimeLeft(timeLeft);
      }, 1000);
    }

    const interval = timers.current.interval;
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logoutTimerOn]);

  return timers.current;
};

export default useLogoutTimers;
